var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m132.522 186.289c-8.105-1.958-16.559-3.021-25.265-3.021-59.236 0-107.257 48.02-107.257 107.257s48.021 107.257 107.257 107.257h116.876v-63.734h-53.252v-.683l84.109-87.837h1.01l20-64.528-20-66.781c-52.963 0-99.135 29.044-123.478 72.07z",
    fill: "#96c8ef"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.743 183.268c-8.706 0-17.16 1.063-25.265 3.021-24.343-43.026-70.516-72.07-123.478-72.07v131.308h1.01l84.109 87.837v.683h-53.252v63.734h116.876c59.236 0 107.257-48.02 107.257-107.257s-48.021-107.256-107.257-107.256z",
    fill: "#69b1e9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.62d4a4b96d212ee82042d1efabf87b17.svg";
export { ForwardRef as ReactComponent };